import {EnquadramentoException} from './enquadramento-exception';
import {ErrorObservable} from "rxjs-compat/observable/ErrorObservable";
import {HttpResponse} from '@angular/common/http';

function handleUnavailableBackend(error: HttpResponse<any> | any) {

  if (error instanceof HttpResponse) {
    if (error.status === 0 || error.status === 408 || error.status === 503) {
      return 'Não foi possível estabelecer uma conexão com o serviço.';
    }
  }

    return null;
}

export function handleError(error: HttpResponse<any> | any) {

  // let errorMsg: string = handleUnavailableBackend(error);
  // let deveLogar = true;
  // if (!errorMsg) {
  //   if (error instanceof HttpResponse) {
  //     errorMsg = error.statusText;
  //     if (isEmAutorizacaoException(error)) {
  //       deveLogar = false;
  //     }
  //   } else {
  //     errorMsg = error.message ? error.message : error.toString();
  //   }
  // }

  const errorMsg = error.message ? error.message : error.toString();
  return ErrorObservable.create(errorMsg);
}

/**
 * Handler para extrair a mensagem de erro em Requests que esperam ArrayBuffer (por ex: download de arquivos).
 *
 */
export function handleErrorArrayBuffer(error: HttpResponse<any>) {
  const errorMsg: string = handleUnavailableBackend(error);
  if (errorMsg) {
    console.error(errorMsg);
    return ErrorObservable.create(errorMsg);
  }

    let json;
  if ('TextDecoder' in window) {
    // Decode como UTF-8 nos browsers que suportam
    const dataView = new DataView(error.body);
    const w = window as any;
    const decoder = new w.TextDecoder('utf8');
    try {
      json = JSON.parse(decoder.decode(dataView));
    } catch (e) {
      json = null;
    }
  } else {
    // Fallback como ASCII
    const decodedString = String.fromCharCode.apply(null, new Uint8Array(error.body));
    json = JSON.parse(decodedString);
  }

    if (!json) {
      // NÃ£o encontrou erro no arrayBuffer, utiliza o tratamento default
      return handleError(error);
    }
  return ErrorObservable.create(json.message);
}

export function isEmAutorizacaoException(error: HttpResponse<any>) {
  if (error.status === 500) {
    const e = error.body as EnquadramentoException;
    if (e.exception && e.exception.includes('AguardandoConferenciaException')) {
      return true;
    }
  }
    return false;
}
